import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import { getErrorsByPath } from '../../helpers';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  errors: object;
}

const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>((props, ref) => {
  const {
    label, name, errors = {}, ...inputProps
  } = props;

  const hasError = !!getErrorsByPath(errors, name);

  return (
    <div className='mb-5'>
      <label className='block text-sm font-medium leading-6 text-black'>
        {label}
        {props.required && <span className='text-red-500'> *</span>}
      </label>
      <div className='mt-2'>
        <input
          {...inputProps}
          ref={ref}
          name={name}
          className={classNames(
            'block w-full rounded-md border-0 py-2.5 shadow-sm ring-1 ring-inset focus:ring-1 focus:ring-inset disabled:bg-zinc-100 sm:text-sm sm:leading-6',
            hasError
              ? 'ring-red-500 focus:ring-red-500 text-red-900 placeholder:text-red-300'
              : 'ring-gray-300 focus:ring-primary text-black placeholder:text-gray-400',
          )}
          autoComplete='off'
        />
      </div>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <p className='text-red-500 text-xs mt-2'>{message}</p>}
      />
    </div>
  );
});

export default InputField;
